export default __webpack_public_path__ + "static/media/bg-cubes-horizontal.7c69b1a2.png";